import { render } from "./BikeGarageApp.vue?vue&type=template&id=215aaffd&scoped=true"
import script from "./BikeGarageApp.vue?vue&type=script&lang=js"
export * from "./BikeGarageApp.vue?vue&type=script&lang=js"

import "./BikeGarageApp.vue?vue&type=style&index=0&id=215aaffd&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215aaffd"]])

export default __exports__